// src/components/Blocks/Listing/DownloadListingBlockTemplate.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { flattenToAppURL } from '@plone/volto/helpers';
import './DownloadListingBlockTemplate.less';

/**
 * Simple download listing template
 * - Displays all items as buttons with download icons
 * - All links open in a new tab
 */

export default function DownloadListingBlockTemplate(props) {
  const { items = [] } = props;

  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div className="download-listing">
      <h2>Downloads</h2>
      <ul className="download-listing__list">
        {items.map((item, idx) => {
          const url = flattenToAppURL(item['@id'] || item.url || '');
          const title = item.title || 'Untitled';

          return (
            <li key={item['@id'] || idx} className="download-listing__item">
              <a
                href={url}
                className="download-listing__button"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-download" aria-hidden="true"></i>
                <span className="download-listing__title">{title}</span>
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

DownloadListingBlockTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
};
